import type { CompositePrimaryKey, GlobalCollectionId } from '#layers/data-model/public';
import { createContext } from 'reka-ui';

export type OpenRelatedItemDrawer = (
	collectionId: GlobalCollectionId,
	options: { selection: CompositePrimaryKey[] },
) => Promise<CompositePrimaryKey[] | null>;

const [injectRelatedItemDrawer, provideRelatedItemDrawer] = createContext<OpenRelatedItemDrawer>('RelatedItemDrawer');

export { provideRelatedItemDrawer };

const openRelatedItemDrawerNoop: OpenRelatedItemDrawer = () => {
	if (import.meta.dev) {
		console.warn('[useRelatedItemDrawer] No related-item drawer provided; call provideRelatedItemDrawer() in the host. Related-item picking is disabled.');
	}

	return Promise.resolve(null);
};

export function useRelatedItemDrawer(): OpenRelatedItemDrawer {
	return injectRelatedItemDrawer(null) ?? openRelatedItemDrawerNoop;
}
